module.exports = __webpack_public_path__ + "img/elektro-i-benzoinstrument.e7cb785f.svg";